import {
    Grid,
    Select,
    MenuItem
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import React, { memo } from "react";
import clsx from "clsx";

const useStyle = makeStyles({
    font: {
        fontFamily: "DB Heavent",
    },
    primaryText: {
        color: "var(--primary)"
    }
});

const CustomDropDownList = (props) => {
    const classes = useStyle();
    const { lang, data, value, page } = props;
    const change = (name) => {
        if (props.onChange) {
            props.onChange(name);
        }
    }

    return (
        <>
            {page === "career" ? (
                <Select
                    value={value}
                    onChange={change}
                >
                    {data.map(({ Id, ThName, EnName }) => (
                        <MenuItem
                            key={Id}
                            value={Id}
                            placeholder="อาชีพ">
                            {lang === "th" ? ThName : EnName}
                        </MenuItem>
                    ))
                    }
                </Select>
            ) : (
                <select
                    className={clsx(classes.font, classes.primaryText, "font-20 select-deco option-deco")}
                    value={value}
                    onChange={change}
                >
                    {page === "income" ? (
                        data.map(({ Mfnt_Id, Mfnt_NameEn, Mfnt_NameTh }) => (
                            <option
                                key={value.includes("Other") && Mfnt_NameEn.includes("Other") ? Mfnt_Id : Mfnt_Id}
                                value={Mfnt_NameEn}>
                                {lang === "th" ? Mfnt_NameTh : Mfnt_NameEn}
                            </option>
                        ))
                    ) : (
                        page === "purpose" || page === "asset" ? (
                            data.map(({ Id, EnName, ThName }) => (
                                <option
                                    key={Id}
                                    value={Id}
                                    placeholder="กรุณาเลือก">
                                    {lang === "th" ? ThName : EnName}
                                </option>
                            ))
                        ) : (
                            <Grid></Grid>
                        )
                    )
                    }
                </select>
            )
            }
        </>
    );
};

export default memo(CustomDropDownList);